import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpurcab() {



  const cardData = {




keyword: "Pune to Nagpur Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Nagpur Cab Service for business travelers, families, students, professionals, couples, and groups planning a long-distance road journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, business visits, family functions, relocation, medical travel, and customized Nagpur itineraries. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes the Pune to Nagpur journey convenient and comfortable. Travelers can also include important attractions, pilgrimage destinations, wildlife areas, and nearby Vidarbha destinations according to their preferred travel schedule.",

topPlaces: [
  {
    title: "Futala Lake",
    description: "Futala Lake is one of Nagpur's popular leisure destinations, known for its scenic surroundings, evening atmosphere, and relaxing waterfront views. It is a suitable place for families, couples, and visitors looking to unwind after a long journey. Travelers booking a private cab from Pune can conveniently include Futala Lake in their Nagpur sightseeing itinerary."
  },
  {
    title: "Deekshabhoomi",
    description: "Deekshabhoomi is an important Buddhist monument and spiritual landmark in Nagpur, attracting visitors interested in history, culture, and Buddhist heritage. Its peaceful surroundings make it a significant destination for pilgrims and tourists. Garud Cab Service provides comfortable chauffeur-driven transportation from Pune, allowing travelers to visit Deekshabhoomi and other important attractions conveniently."
  },
  {
    title: "Dikshabhoomi to Seminary Hills",
    description: "Seminary Hills is a green and elevated area of Nagpur known for scenic surroundings, walking areas, and views across parts of the city. It provides a relaxing sightseeing experience for families and nature lovers. Customers traveling from Pune can use a private cab to explore Seminary Hills along with other Nagpur attractions according to their preferred schedule."
  },
  {
    title: "Sitabuldi Fort",
    description: "Sitabuldi Fort is a historic landmark in central Nagpur associated with the city's military and colonial-era history. The location offers an interesting experience for travelers interested in heritage and architecture. A private cab makes it convenient for visitors arriving from Pune to reach the fort area and continue their sightseeing across central Nagpur."
  },
  {
    title: "Ambazari Lake",
    description: "Ambazari Lake is one of Nagpur's well-known lakes and a popular recreational area surrounded by greenery and open spaces. It is suitable for families and travelers looking for a peaceful break during their city visit. Garud Cab Service can provide private transportation for Pune travelers who want to include Ambazari Lake in their customized Nagpur itinerary."
  },
  {
    title: "Tadoba-Andhari Tiger Reserve",
    description: "Tadoba-Andhari Tiger Reserve is one of Maharashtra's most popular wildlife destinations and is known for its forests, wildlife safaris, and opportunities to spot tigers. Travelers from Pune can combine Nagpur with a Tadoba visit as part of a longer road trip. Garud Cab Service offers suitable vehicles for families and groups planning private transportation toward the reserve and nearby stay locations."
  },
  {
    title: "Pench National Park",
    description: "Pench National Park is a renowned wildlife destination located near the Maharashtra-Madhya Pradesh region and is known for forests, wildlife, and safari experiences. It is an excellent addition for nature lovers extending their Nagpur journey. Customers can book a private cab from Pune and customize their itinerary to include Nagpur, Pench, and other nearby destinations."
  },
  {
    title: "Ramtek",
    description: "Ramtek is a historic and religious destination near Nagpur known for its hilltop temple, scenic surroundings, and association with Lord Rama. It is frequently visited by devotees and travelers interested in heritage and spirituality. A chauffeur-driven cab provides convenient transportation for Pune travelers who want to combine Ramtek with their Nagpur trip."
  },
  {
    title: "Wardha",
    description: "Wardha is an important destination near Nagpur with strong historical and cultural associations, including places connected with Mahatma Gandhi and India's freedom movement. It is suitable for travelers interested in heritage, history, and peaceful surroundings. Garud Cab Service can arrange private transportation from Pune to Nagpur with Wardha included as an additional stop in a customized itinerary."
  },
  {
    title: "Sevagram",
    description: "Sevagram is a historically significant destination near Wardha associated with Mahatma Gandhi and his life and work. The area attracts visitors interested in India's freedom movement and Gandhian heritage. Travelers from Pune can include Sevagram in a customized Nagpur journey and enjoy private chauffeur-driven transportation with flexible sightseeing and return arrangements."
  }
],



"services": [
{
"name": "Cab from Nagpur to Pune",
"description": "Book Cab from Nagpur to Pune for a comfortable and convenient long-distance journey with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family trips, business travel, personal visits, and one-way or round-trip journeys."
},
{
"name": "Cab Pune to Nagpur",
"description": "Choose Cab Pune to Nagpur for reliable intercity transportation with experienced chauffeurs, comfortable AC interiors, convenient pickup, and direct destination drop. The service is suitable for families, corporate travelers, tourists, individuals, and groups traveling between Pune and Nagpur."
},
{
"name": "Nagpur to Pune Cab",
"description": "Book Nagpur to Pune Cab for a private and comfortable road journey with professional driver service and flexible pickup arrangements. Select a Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to passenger count, luggage requirements, travel duration, and preferred comfort."
},
{
"name": "Nagpur to Pune Cab Booking",
"description": "Make Nagpur to Pune Cab Booking for a scheduled chauffeur-driven journey with convenient pickup and direct drop facilities. Choose your preferred vehicle category according to your travel date, passenger capacity, luggage needs, and journey type for family, corporate, personal, and outstation travel."
},
{
"name": "Nagpur to Pune Cab Price",
"description": "Check Nagpur to Pune Cab Price according to the selected vehicle, passenger count, journey type, travel requirements, and trip plan. Choose economical Sedan options or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles for comfortable long-distance travel."
},
{
"name": "Nagpur to Pune Taxi",
"description": "Choose Nagpur to Pune Taxi for dependable private transportation with professional chauffeurs and comfortable AC vehicles. The service is suitable for family travel, business visits, personal journeys, sightseeing, airport transfers, and passengers looking for convenient point-to-point transportation."
},
{
"name": "Nagpur to Pune Taxi Fare",
"description": "Get Nagpur to Pune Taxi Fare information based on your preferred vehicle category, passenger capacity, luggage requirements, and travel plan. Select from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for comfortable one-way or round-trip journeys."
},
{
"name": "One Way Cab from Pune to Nagpur",
"description": "Book One Way Cab from Pune to Nagpur for a direct point-to-point journey without arranging a return trip. Enjoy convenient pickup from your home, office, hotel, or other Pune location with professional chauffeur service, clean AC vehicles, and suitable options for individuals, families, and corporate travelers."
},
{
"name": "Pune Nagpur Cab Service",
"description": "Choose Pune Nagpur Cab Service for reliable long-distance transportation with experienced chauffeurs, comfortable AC vehicles, and convenient door-to-door pickup and drop facilities. The service is suitable for family trips, business travel, personal visits, sightseeing, and planned outstation journeys."
},
{
"name": "Pune to Nagpur Cab Booking",
"description": "Reserve Pune to Nagpur Cab Booking for a comfortable private journey with scheduled pickup and direct destination drop. Select a Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your passenger count, luggage requirements, and preferred travel comfort."
},
{
"name": "Pune to Nagpur Cab Charges",
"description": "Check Pune to Nagpur Cab Charges according to your selected vehicle, journey type, passenger requirements, and travel plan. Choose economical sedan cars or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for comfortable family, business, and personal travel."
},
{
"name": "Pune to Nagpur Cab Service",
"description": "Book Pune to Nagpur Cab Service for convenient intercity transportation with professional chauffeurs and well-maintained air-conditioned vehicles. Flexible pickup locations and multiple vehicle choices make the service suitable for families, tourists, corporate passengers, individuals, and groups."
},
{
"name": "Pune to Nagpur Taxi",
"description": "Choose Pune to Nagpur Taxi for comfortable private travel with professional chauffeur service, AC interiors, practical luggage space, and convenient pickup and drop arrangements. The service is suitable for long-distance family journeys, corporate travel, personal visits, and planned outstation trips."
},
{
"name": "Pune to Nagpur Taxi Fare",
"description": "Get Pune to Nagpur Taxi Fare details according to the selected vehicle category, passenger count, travel requirements, and journey type. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles for comfortable one-way, return, business, family, and personal journeys."
},
{
"name": "Pune to Nagpur Cab Booking Online",
"description": "Make Pune to Nagpur Cab Booking Online for convenient scheduled transportation with private chauffeur service and direct destination drop. Select your preferred vehicle according to your travel date, passenger capacity, luggage requirements, and comfort preferences for a hassle-free long-distance journey."
},
{
"name": "Pune to Nagpur Taxi Booking Online",
"description": "Book Pune to Nagpur Taxi Booking Online for a convenient private journey with professional chauffeurs and comfortable AC vehicles. Online booking arrangements make it easier to plan airport transfers, family trips, corporate travel, personal visits, and long-distance transportation according to your schedule."
},
{
"name": "Pune to Nagpur Cab Fare",
"description": "Check Pune to Nagpur Cab Fare according to the selected vehicle, journey type, passenger count, luggage capacity, and travel requirements. Choose from economical Sedan options or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles for comfortable intercity travel."
},
{
"name": "Pune to Nagpur Taxi Charges",
"description": "Get Pune to Nagpur Taxi Charges based on your preferred vehicle category and travel plan. Choose comfortable chauffeur-driven Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for family journeys, business travel, sightseeing, personal visits, and one-way or round-trip transportation."
},
{
"name": "Best Pune to Nagpur Cab Service",
"description": "Choose Best Pune to Nagpur Cab Service for dependable long-distance transportation with experienced chauffeurs, clean AC vehicles, convenient pickup, and comfortable seating. Multiple vehicle categories are available for individuals, families, corporate travelers, tourists, and groups."
},
{
"name": "Cheap Pune to Nagpur Cab",
"description": "Book Cheap Pune to Nagpur Cab for economical long-distance travel while choosing a vehicle that matches your passenger and luggage requirements. Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options provide practical choices for families, individuals, business travelers, and groups."
},
{
"name": "Pune to Nagpur One Way Cab",
"description": "Reserve Pune to Nagpur One Way Cab for direct transportation from Pune to Nagpur without requiring a return booking. Enjoy private AC travel, professional chauffeur service, convenient pickup, and suitable vehicle options for personal journeys, family trips, corporate travel, and relocation requirements."
},
{
"name": "Pune to Nagpur Round Trip Taxi",
"description": "Book Pune to Nagpur Round Trip Taxi for convenient return transportation according to your travel schedule. Enjoy private AC travel, experienced chauffeur service, comfortable seating, and spacious luggage capacity for business visits, family journeys, sightseeing, personal travel, and extended stays."
},
{
"name": "Pune to Nagpur Innova Cab",
"description": "Choose Pune to Nagpur Innova Cab for spacious and comfortable long-distance transportation with a professional chauffeur. Toyota Innova is suitable for families and small groups requiring practical seating, luggage space, AC comfort, and convenient private travel between Pune and Nagpur."
},
{
"name": "Pune to Nagpur Innova Crysta Cab",
"description": "Book Pune to Nagpur Innova Crysta Cab for premium and spacious long-distance travel with comfortable AC interiors and professional chauffeur service. The vehicle is suitable for families, corporate travelers, senior passengers, tourists, and groups looking for enhanced comfort on an extended road journey."
},
{
"name": "Pune to Nagpur Ertiga Cab",
"description": "Reserve Pune to Nagpur Ertiga Cab for comfortable family and group transportation with practical seating, luggage capacity, and air-conditioned interiors. Ertiga is suitable for passengers planning one-way trips, round trips, business travel, family visits, and personal journeys."
},
{
"name": "Pune to Nagpur Sedan Cab",
"description": "Choose Pune to Nagpur Sedan Cab for economical and comfortable private transportation with professional chauffeur service. Sedan options are suitable for individuals, couples, small families, and corporate passengers who prefer a practical AC vehicle for long-distance travel."
},
{
"name": "Pune to Nagpur SUV Taxi",
"description": "Book Pune to Nagpur SUV Taxi for spacious and comfortable long-distance transportation with professional chauffeur service. SUV vehicles provide additional seating and luggage flexibility for families, groups, tourists, corporate travelers, and passengers planning extended road journeys."
},
{
"name": "Pune to Nagpur AC Cab",
"description": "Choose Pune to Nagpur AC Cab for comfortable long-distance travel in a clean and well-maintained air-conditioned vehicle. Enjoy professional chauffeur service, convenient pickup, comfortable seating, luggage space, and flexible vehicle options for family, business, tourist, and personal journeys."
},
{
"name": "Pune to Nagpur Luxury Cab",
"description": "Reserve Pune to Nagpur Luxury Cab for premium chauffeur-driven transportation with spacious interiors and enhanced travel comfort. Premium vehicle options are suitable for corporate travel, family journeys, special trips, business visits, and passengers seeking a more comfortable long-distance road travel experience."
},
{
"name": "Pune Airport to Nagpur Cab",
"description": "Book Pune Airport to Nagpur Cab for convenient airport pickup and direct transportation toward Nagpur. Professional chauffeurs, luggage-friendly vehicles, scheduled pickup, and comfortable AC interiors make the service suitable for business travelers, families, tourists, and passengers continuing an intercity journey."
},
{
"name": "Hinjewadi to Nagpur Taxi",
"description": "Choose Hinjewadi to Nagpur Taxi for comfortable long-distance transportation from Pune's major IT hub to Nagpur. Enjoy convenient pickup from offices, residential areas, hotels, or other locations with professional chauffeur service and suitable Sedan, Ertiga, Innova, Innova Crysta, and SUV options."
},
{
"name": "Wakad to Nagpur Cab",
"description": "Book Wakad to Nagpur Cab for reliable private transportation with convenient pickup from residential, commercial, and business locations in Wakad. Comfortable AC vehicles and professional chauffeurs make the service suitable for families, corporate passengers, tourists, and individuals."
},
{
"name": "Hadapsar to Nagpur Taxi",
"description": "Reserve Hadapsar to Nagpur Taxi for comfortable intercity travel with scheduled pickup and direct destination drop. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles according to passenger capacity, luggage requirements, and preferred travel comfort."
},
{
"name": "Pimpri Chinchwad to Nagpur Cab",
"description": "Choose Pimpri Chinchwad to Nagpur Cab for convenient long-distance transportation from PCMC to Nagpur. Professional chauffeur service, comfortable AC interiors, practical luggage space, and multiple vehicle choices make the service suitable for families, corporate travelers, groups, and personal journeys."
},
{
"name": "Pune to Nagpur Corporate Cab",
"description": "Book Pune to Nagpur Corporate Cab for professional and comfortable business transportation between Pune and Nagpur. Enjoy scheduled pickup, experienced chauffeurs, clean AC vehicles, comfortable seating, and suitable Sedan, Innova, Innova Crysta, and premium options for meetings, corporate visits, and business travel."
},
{
"name": "Pune to Nagpur Business Travel Taxi",
"description": "Choose Pune to Nagpur Business Travel Taxi for dependable private transportation designed for corporate journeys and professional visits. Enjoy convenient pickup, comfortable AC travel, experienced chauffeurs, luggage space, and vehicle options suitable for individual executives, teams, and business travelers."
},
{
"name": "Pune to Nagpur Family Trip Cab",
"description": "Reserve Pune to Nagpur Family Trip Cab for a comfortable private road journey with spacious seating and practical luggage capacity. Choose Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for families and groups planning long-distance travel with convenient pickup and direct drop."
}
],
"tableData": [
["Cab from Nagpur to Pune", "Cab Pune to Nagpur"],
["Nagpur to Pune Cab", "Nagpur to Pune Cab Booking"],
["Nagpur to Pune Cab Price", "Nagpur to Pune Taxi"],
["Nagpur to Pune Taxi Fare", "One Way Cab from Pune to Nagpur"],
["Pune Nagpur Cab Service", "Pune to Nagpur Cab Booking"],
["Pune to Nagpur Cab Charges", "Pune to Nagpur Cab Service"],
["Pune to Nagpur Taxi", "Pune to Nagpur Taxi Fare"],
["Pune to Nagpur Cab Booking Online", "Pune to Nagpur Taxi Booking Online"],
["Pune to Nagpur Cab Fare", "Pune to Nagpur Taxi Charges"],
["Best Pune to Nagpur Cab Service", "Cheap Pune to Nagpur Cab"],
["Pune to Nagpur One Way Cab", "Pune to Nagpur Round Trip Taxi"],
["Pune to Nagpur Innova Cab", "Pune to Nagpur Innova Crysta Cab"],
["Pune to Nagpur Ertiga Cab", "Pune to Nagpur Sedan Cab"],
["Pune to Nagpur SUV Taxi", "Pune to Nagpur AC Cab"],
["Pune to Nagpur Luxury Cab", "Pune Airport to Nagpur Cab"],
["Hinjewadi to Nagpur Taxi", "Wakad to Nagpur Cab"],
["Hadapsar to Nagpur Taxi", "Pimpri Chinchwad to Nagpur Cab"],
["Pune to Nagpur Corporate Cab", "Pune to Nagpur Business Travel Taxi"],
["Pune to Nagpur Family Trip Cab", "Pune to Nagpur Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Nagpur Cab for a Smooth Long-Distance Journey",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Nagpur cab services for families, professionals, students, couples, and groups seeking convenient road transportation between Pune and Nagpur."
  },
  {
    WhyChooseheading: "Direct Travel Without Vehicle Changes",
    WhyChoosedescription: "Travel directly from your preferred location in Pune to your destination in Nagpur in a dedicated cab, making the journey practical for passengers carrying luggage or travelling together as a family."
  },
  {
    WhyChooseheading: "Comfortable Options for Different Groups",
    WhyChoosedescription: "Select a suitable vehicle based on the number of passengers, luggage requirements, and preferred comfort level so your long-distance journey is planned around your actual needs."
  },
  {
    WhyChooseheading: "One-Way Cab for Relocation or Personal Travel",
    WhyChoosedescription: "A one-way Pune to Nagpur cab is a useful choice for relocation, education, family visits, joining a new workplace, or travelling to Nagpur without requiring a return vehicle."
  },
  {
    WhyChooseheading: "Round-Trip Option for Scheduled Visits",
    WhyChoosedescription: "If your Nagpur visit has a fixed duration, arrange a round-trip cab around your work schedule, family plans, sightseeing activities, or preferred return date."
  },
  {
    WhyChooseheading: "Useful for Business & Professional Trips",
    WhyChoosedescription: "Private cab transportation can support corporate meetings, project visits, client appointments, office assignments, industrial travel, and other professional journeys between Pune and Nagpur."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Pune Location",
    WhyChoosedescription: "Start your Nagpur journey from your home, hotel, office, residential society, railway station area, or another convenient pickup point in Pune."
  },
  {
    WhyChooseheading: "Arrange Your Nagpur Cab with Garud",
    WhyChoosedescription: "Provide your Pune pickup location, Nagpur destination, travel date, passenger count, luggage details, preferred vehicle, and one-way or return requirement to Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Nagpur Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Nagpur cab services for families, business travellers, students, couples, groups, and passengers travelling for personal requirements."
  },
  {
    question: "Can I book a one-way cab from Pune to Nagpur?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to their preferred destination in Nagpur."
  },
  {
    question: "Can I book a round-trip Pune to Nagpur cab?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Nagpur stay, work schedule, family visit, sightseeing plans, and preferred return date."
  },
  {
    question: "Which vehicles are available for Pune to Nagpur travel?",
    answer: "Vehicle options can be arranged according to passenger count, luggage requirements, comfort preferences, and availability at the time of booking."
  },
  {
    question: "Is Pune to Nagpur cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families who want to travel together with flexible departure timings and convenient luggage arrangements."
  },
  {
    question: "Can I use the cab for business travel to Nagpur?",
    answer: "Yes, the cab can be used for business meetings, client visits, project work, office assignments, industrial visits, and other professional travel requirements."
  },
  {
    question: "Can I book a cab for relocation from Pune to Nagpur?",
    answer: "Yes, a private cab can be considered for relocation or personal shifting requirements, subject to the luggage capacity of the selected vehicle."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can the cab drop me directly at my Nagpur address?",
    answer: "Yes, direct drop-off can be arranged at your home, hotel, office, apartment, residential location, or another accessible destination in Nagpur."
  },
  {
    question: "How can I book a Pune to Nagpur Cab?",
    answer: "Share your Pune pickup location, Nagpur destination, travel date, passenger details, luggage requirements, preferred vehicle, and trip type with Garud Cab Service to arrange your cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Wagh",
    feedback: "Our family booked a private cab from Pune to Nagpur for a personal visit. The direct journey was convenient because we could travel together with our luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Joshi",
    feedback: "I arranged a Pune to Nagpur cab for a work-related trip. Having a private vehicle gave me more flexibility compared with changing between different modes of transport.",
    rating: 5
  }
];





















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nagpur Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-nagpur-cab.webp",
  "description": "Book Pune to Nagpur Cab with Garud Cab for safe, comfortable, and reliable long-distance travel. Get one way and round trip cab services between Pune and Nagpur with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for family journeys, business travel, relocation, and intercity trips with convenient pickup and drop facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-nagpur-cab"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune to Nagpur Cab | One Way Taxi & Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Nagpur Cab with Garud Cab for comfortable and reliable long-distance travel. Get one way and round trip taxi services between Pune and Nagpur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cab options."
  />

  <meta
    name="keywords"
    content="Cab from Nagpur to Pune, Cab Pune to Nagpur, Nagpur to Pune Cab, Nagpur to Pune Cab Booking, Nagpur to Pune Cab Price, Nagpur to Pune Taxi, Nagpur to Pune Taxi Fare, One Way Cab from Pune to Nagpur, Pune to Nagpur Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonagpurcab;